function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBalloon = function SvgBalloon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 60,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.511 0C8.75 0 0 8.762 0 19.524c0 8.987 6.15 20.648 15.099 23.748v5.337c0 .7.563 1.25 1.25 1.25h1.916v8.891a1.25 1.25 0 102.5 0v-8.89h1.909c.7 0 1.25-.55 1.25-1.25v-5.338c8.949-3.1 15.111-14.761 15.111-23.748C39.035 8.762 30.273 0 19.511 0zm10.821 16.963c-.69 0-1.25-.56-1.25-1.25A6.361 6.361 0 0022.73 9.36a1.25 1.25 0 110-2.5c4.881 0 8.853 3.972 8.853 8.854 0 .69-.559 1.25-1.25 1.25z",
    style: {
      fill: "var(--color-primary)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBalloon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balloon.4f5bb518.svg";
export { ForwardRef as ReactComponent };